import { ChangePasswordForm } from 'modules/auth/components/ChangePasswordForm/ChangePasswordForm'
import { Illustration } from 'modules/common/components/Illustrations/Illustration'
import { Seo } from 'modules/common/components/Seo/Seo'
import { IconArrowLeft } from 'modules/common/components/_icons/icons'
import LayoutLogin from 'modules/common/components/_layouts/LayoutLogin'
import { Button } from 'modules/common/components/_ui/Button/Button'
import { useTranslation } from 'modules/common/hooks/useTranslation'
import { EnumRoutes } from 'modules/common/routes'
import { BlankPage } from 'modules/common/types/page'
import { GetStaticProps } from 'next'
import { Trans } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { useRouter } from 'next/router'

const ChangePasswordRequest: BlankPage = () => {
  const router = useRouter()
  const { t } = useTranslation('auth-page-change-password-request')

  const loginRedirect = () => {
    router.push(EnumRoutes.LOGIN)
  }

  return (
    <div className="flex max-w-xs flex-col items-center">
      <Seo
        title={t('meta.title')}
        description={t('meta.description')}
        noindex
      />
      <Illustration name="mail" size="l" />
      <h2 className="py-4 text-center">{t('h1')}</h2>
      <p className="pb-4 text-center text-info-600">{t('description')}</p>
      <ChangePasswordForm className="w-full pb-6" />
      <Button
        variant="secondary"
        color="default"
        className="items-center justify-center self-stretch"
        onClick={loginRedirect}
        icon={
          <IconArrowLeft className="inline translate-x-1 transition-transform" />
        }
      >
        <Trans parent="p">{t('backButton')}</Trans>
      </Button>
    </div>
  )
}

export const getStaticProps: GetStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale as string, [
      'common',
      'common-components',
      'auth-page-change-password-request',
      'auth-components',
    ])),
  },
})

ChangePasswordRequest.getLayout = (page: any) => (
  <LayoutLogin>{page}</LayoutLogin>
)
ChangePasswordRequest.type = 'notAuthenticated'

export default ChangePasswordRequest
